import { render, staticRenderFns } from "./quick-reply.vue?vue&type=template&id=8ae879ee&scoped=true&"
import script from "./quick-reply.vue?vue&type=script&lang=js&"
export * from "./quick-reply.vue?vue&type=script&lang=js&"
import style0 from "./quick-reply.vue?vue&type=style&index=0&id=8ae879ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae879ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
